import React from 'react';

export enum ModalSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export interface ModalProps {
  /**
   * Modal title
   */
  title: string;
  /**
   * Optional eyebrow text that appears above the title
   */
  eyebrow?: string;
  /**
   * Optional CSS for eyebrow text
   */
  eyebrowClassName?: string;
  /**
   * Optional secondary eyebrow text that appears after the main eyebrow
   */
  secondaryEyebrow?: string;
  /**
   * Modal content
   */
  children: React.ReactNode;
  /**
   * Whether the modal is currently open
   */
  isOpen: boolean;
  /**
   * Function to call when the modal should close
   */
  onClose: () => void;
  /**
   * Modal size
   */
  size?: ModalSize;
  /**
   * Whether to render a close button in the header
   */
  showCloseButton?: boolean;
  /**
   * Custom CSS class
   */
  className?: string;
  /**
   * Modal subtitle
   */
  subtitle?: React.ReactNode;
  /**
   * Error Message
   */
  errorMessage?: string;
  /**
   * When true, disable all user-initiated closing (esc, backdrop click, header close)
   */
  disableClose?: boolean;
  /**
   * Optional sticky footer content
   */
  footerContent?: React.ReactNode;
}
